import { GridComponent, ELoadingStatus } from './components/grid.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid';

import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
  TemplateRef,
  ViewChild,
  NgZone,
  Inject,
  forwardRef
} from '@angular/core';

import { isEqual, isNil, isEmpty, set } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';
import { BaseComponent } from './components/base.component';
import { SharedModule } from './shared.module';import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { datCodeValidator } from './components/code-validator.directive';import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Totes_ShellService } from './Totes.shell.service';
import { Totes_OperationService } from './Totes.operation.service';
import { Totes_DatasourceService } from './Totes.datasource.index';
import { Totes_FlowService } from './Totes.flow.index';
import { Totes_FrontendFlowService } from './Totes.frontend.flow.service';
import { Totes_ReportService } from './Totes.report.index';
import { Totes_LocalizationService } from './Totes.localization.service';
import { Totes_tote_containers_grid_ComponentContextService } from './Totes.tote_containers_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './Totes.frontend.types'
import { $frontendTypes as $types} from './Totes.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Totes_tote_container_statuses_dd_singleComponent } from './Totes.tote_container_statuses_dd_single.component'
import { Totes_tote_container_types_dd_singleComponent } from './Totes.tote_container_types_dd_single.component'
import { Totes_warehouses_dd_singleComponent } from './Totes.warehouses_dd_single.component'


interface ITotes_tote_containers_gridComponentEntity {
  Id?: number, ContainerTypeId?: number, LookupCode?: string, StatusId?: number, WarehouseId?: number, Status?: { Name?: string }, Type?: { Description?: string, Name?: string }, Warehouse?: { Name?: string }}



class Totes_tote_containers_gridComponentRowModel extends GridRowModel {
  grid: Totes_tote_containers_gridComponent;
  entity: ITotes_tote_containers_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    lookup_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    status_name_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    type_name_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    type_description_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    warehouse_name_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  override cells = {
    lookup: null,
    status_name: null,
    type_name: null,
    type_description: null,
    warehouse_name: null,
  }



  constructor(
    grid: Totes_tote_containers_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: Totes_ShellService,
private $datasources: Totes_DatasourceService,
private $flows: Totes_FlowService,
private $frontendFlows: Totes_FrontendFlowService,
private $reports: Totes_ReportService,
private $localization: Totes_LocalizationService,
private $operations: Totes_OperationService,
private $logger: CleanupLoggerService,
private $context: Totes_tote_containers_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.lookup = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.lookup,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['lookup_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.status_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.status_name,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['status_name_edit'] as DatexFormControl, 
        ESelectBoxType.dropdown, null,
        false,
        false,
        '', null)
      );
    
    this.cells.type_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.type_name,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['type_name_edit'] as DatexFormControl, 
        ESelectBoxType.dropdown, null,
        false,
        false,
        '', null)
      );
    
    this.cells.type_description = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.type_description,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['type_description_edit'] as DatexFormControl, null, true, false, '', null)
      );
    
    this.cells.warehouse_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.warehouse_name,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['warehouse_name_edit'] as DatexFormControl, 
        ESelectBoxType.dropdown, null,
        false,
        false,
        '', null)
      );
    
    
  }

  async $initializeExisting(entity: ITotes_tote_containers_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: ITotes_tote_containers_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const $inParams: { lookupCode?: string, warehouseId?: number, $keys: number[] } = {
      $keys:[$resultKey],
      lookupCode:  null ,
      warehouseId:  null ,
    };
    const $data = await this.$datasources.Totes.ds_get_tote_containers.getByKeys($inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns($inParams, $data);
      
    this.entity = $data.result[0] as ITotes_tote_containers_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.lookup.displayControl as TextModel).text = $row.entity.LookupCode;
    (this.cells.lookup.editControl as TextBoxModel).reset($row.entity.LookupCode);
    (this.cells.status_name.displayControl as TextModel).text = $row.entity.Status?.Name;
    (this.cells.status_name.editControl as SelectBoxModel).reset($row.entity.StatusId);
    (this.cells.type_name.displayControl as TextModel).text = $row.entity.Type?.Name;
    (this.cells.type_name.editControl as SelectBoxModel).reset($row.entity.ContainerTypeId);
    (this.cells.type_description.displayControl as TextModel).text = $row.entity.Type?.Description;
    (this.cells.type_description.editControl as TextBoxModel).reset($row.entity.Type?.Description);
    (this.cells.warehouse_name.displayControl as TextModel).text = $row.entity.Warehouse?.Name;
    (this.cells.warehouse_name.editControl as SelectBoxModel).reset($row.entity.WarehouseId);

  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      await this.on_save();
      this.isNew = false;
    } else {
      await this.on_save();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_save(event = null) {
    return this.on_saveInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_saveInternal(
    $row: Totes_tote_containers_gridComponentRowModel,
  $grid: Totes_tote_containers_gridComponent, 
    $shell: Totes_ShellService,
    $datasources: Totes_DatasourceService,
    $flows: Totes_FlowService,
    $frontendFlows: Totes_FrontendFlowService,
    $reports: Totes_ReportService,
    $settings: SettingsValuesService,
    $operations: Totes_OperationService,
    $utils: UtilsService,
    $context: Totes_tote_containers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Totes_LocalizationService,
    $event: any
  ) {
    this.$logger.log('Totes', 'tote_containers_grid.on_save');
  try {
  
  
      let lookupCode = $row.cells.lookup.editControl.value
      let status = $row.cells.status_name.editControl.displayText
      let status_value = $row.cells.status_name.editControl.value
      let container_type_id = $row.cells.type_name.editControl.value
      let warehouse_name = $row.cells.warehouse_name.editControl.displayText
      let warehouse_id = $row.cells.warehouse_name.editControl.value
  
      if (($row.cells.lookup.editControl.isChanged ||
          $row.cells.type_name.editControl.isChanged ||
          $row.cells.status_name.editControl.isChanged ||
          $row.cells.warehouse_name.editControl.isChanged)
          && $utils.isDefined($row.entity.Id)) {
          alert('IsChanged')
          let updateResult = (await $flows.Totes.create_delete_or_update_containers({
              container_id: $row.entity.Id,
              container_type_id: container_type_id,
              lookup: lookupCode,
              statusId: status_value,
              warehouse_id: warehouse_id,
              action: 'UPDATE'
  
          }));
          if ($utils.isDefined(updateResult.reasons)) {
              throw new Error(updateResult.reasons.join(', '))
          }
          else {
              await $grid.refresh();
          }
      } else if ($row.cells.lookup.editControl.isChanged && !$utils.isDefined($row.entity.Id)) {
          alert(`IsNew - container: ${container_type_id}, lookup: ${lookupCode}, statusId:  ${status_value}, warehouseId:  ${warehouse_id}`)
          let updateResult = (await $flows.Totes.create_delete_or_update_containers({
              container_type_id: container_type_id,
              lookup: lookupCode,
              statusId: status_value,
              warehouse_id: warehouse_id,
              action: 'CREATE'
  
          }));
          if ($utils.isDefined(updateResult.reasons)) {
              throw new Error(updateResult.reasons.join(', '))
          }
          else {
              await $grid.refresh();
          }
      }
  
  }
  catch (error) {
      $shell.Utilities.showErrorDetails('Save', 'Error on save.', error);
      throw error; // to prevent displayMode 
  }
  
  }
  //#endregion private flows

}


@Component({
  imports: [
    SharedModule,
    forwardRef(() => Totes_tote_container_statuses_dd_singleComponent),
    forwardRef(() => Totes_tote_container_types_dd_singleComponent),
    forwardRef(() => Totes_warehouses_dd_singleComponent),
  ],
  selector: 'Totes-tote_containers_grid',
  templateUrl: './Totes.tote_containers_grid.component.html'
})
export class Totes_tote_containers_gridComponent extends BaseComponent implements OnInit, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: ITotes_tote_containers_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['default','fit-content-table']);

  fullTextSearch: string;



  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     lookup: new GridHeaderModel(new HeaderStyles(null, null), 'lookup', 'Lookup', false, false, null, false),       status_name: new GridHeaderModel(new HeaderStyles(null, null), 'status_name', 'Status', false, false, null, false),       type_name: new GridHeaderModel(new HeaderStyles(null, null), 'type_name', 'Type', false, false, null, false),       type_description: new GridHeaderModel(new HeaderStyles(null, null), 'type_description', 'Type description', false, false, null, false),       warehouse_name: new GridHeaderModel(new HeaderStyles(null, null), 'warehouse_name', 'Warehouse', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: Totes_tote_containers_gridComponentRowModel[] = [];


  topToolbar = {
      delete_button: new ToolModel(new ButtonModel('delete_button', new ButtonStyles(['destructive'], null), false, false, false, 'Delete', 'icon-ic_fluent_delete_20_regular', null)
    , false)
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: Totes_ShellService,
    private $datasources: Totes_DatasourceService,
    private $flows: Totes_FlowService,
    private $frontendFlows: Totes_FrontendFlowService,
    private $reports: Totes_ReportService,
    private $localization: Totes_LocalizationService,
    private $operations: Totes_OperationService,
    private $logger: CleanupLoggerService,
    private $context: Totes_tote_containers_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Tote containers';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 25;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const $inParams: { lookupCode?: string, warehouseId?: number, $top?: number, $skip?: number } = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      lookupCode:  null ,
      warehouseId:  null ,
    };
    try {
      const $data = await this.$datasources.Totes.ds_get_tote_containers.getList($inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns($inParams, $data);

      this.entities = $data.result as ITotes_tote_containers_gridComponentEntity[];
      this.totalCount = $data.totalCount;

      await this.$dataLoaded();
      
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new Totes_tote_containers_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$frontendFlows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns($inParams: any, $outParams: any) {
      const $datasource = { inParams: $inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: Totes_tote_containers_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  async addRow(entity?: ITotes_tote_containers_gridComponentEntity) {
    const row = new Totes_tote_containers_gridComponentRowModel(
      this,
      this.$utils,
      this.$settings,
      this.$shell, 
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$localization,
      this.$operations,
      this.$logger,
      this.$context);
    await row.$initializeNew(entity);
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_delete_clicked(event = null) {
    return this.on_delete_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_delete_clickedInternal(
    $grid: Totes_tote_containers_gridComponent,
  
    $shell: Totes_ShellService,
    $datasources: Totes_DatasourceService,
    $flows: Totes_FlowService,
    $frontendFlows: Totes_FrontendFlowService,
    $reports: Totes_ReportService,
    $settings: SettingsValuesService,
    $operations: Totes_OperationService,
    $utils: UtilsService,
    $context: Totes_tote_containers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Totes_LocalizationService,
    $event: any
  ) {
    this.$logger.log('Totes', 'tote_containers_grid.on_delete_clicked');
  
  if ($grid.selectedRows.length > 0) {
      for (let row of $grid.selectedRows) {
          if (row.entity.StatusId === 1) {
              let deleted = (await $flows.Totes.create_delete_or_update_containers({ action: 'DELETE', container_id: row.entity.Id }))
          } else {
              throw new Error(`Unable to delete container in status ${row.entity.Status.Name}`)
          }
  
      }
  } else {
      throw new Error(`No rows selected for delete`)
  }
  await $grid.refresh()
  }
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: Totes_tote_containers_gridComponent,
  
    $shell: Totes_ShellService,
    $datasources: Totes_DatasourceService,
    $flows: Totes_FlowService,
    $frontendFlows: Totes_FrontendFlowService,
    $reports: Totes_ReportService,
    $settings: SettingsValuesService,
    $operations: Totes_OperationService,
    $utils: UtilsService,
    $context: Totes_tote_containers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Totes_LocalizationService,
    $event: any
  ) {
    this.$logger.log('Totes', 'tote_containers_grid.on_row_selected');
  let canDelete = true;
  
  if($grid.selectedRows.length > 0){
      for(let row of $grid.selectedRows){
          if(row.entity.StatusId !== 1){
              canDelete = false
          }
      }
  }
  
  $grid.topToolbar.delete_button.control.readOnly = !canDelete
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: Totes_tote_containers_gridComponent,
  
    $shell: Totes_ShellService,
    $datasources: Totes_DatasourceService,
    $flows: Totes_FlowService,
    $frontendFlows: Totes_FrontendFlowService,
    $reports: Totes_ReportService,
    $settings: SettingsValuesService,
    $operations: Totes_OperationService,
    $utils: UtilsService,
    $context: Totes_tote_containers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Totes_LocalizationService,
    $event: any
  ) {
    this.$logger.log('Totes', 'tote_containers_grid.on_init');
  $grid.topToolbar.delete_button.control.readOnly = true; 
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
